export const useForecastTableHandler = (data) => {
    return {
        data: data.filteredData,
        tableRows: data.tableRows,
        timeSlots: data.timeSlots,
        isLoading: data.isLoading,
        driverList: data.driverList,
        selectedDriver: data.selectedDriver,
        view: data.currentView,
        selectedDate: data.selectedDate,
        unitId: data.unitId,
        forecastApi: data.forecastApi,
        onForecastPatched: data.onForecastPatched,
    };
};
//# sourceMappingURL=useForecastTableHandler.js.map